var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g(_vm._b({class:_vm.classes,attrs:{"type":_vm.nativeType,"disabled":_vm.disabled || _vm.loading}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.loading)?_c('app-loading-indicator',{staticClass:"-ml-1 mr-3",class:_vm.loadingIndicatorClass}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }